export default {
  '/KxreR': 'Inventory Accuracy',
  '2MYr1m': 'Login',
  '4/Lg7X': 'Please enter login password',
  '7wofGo': 'apply',
  '9UZxwP': 'Please enter verification code',
  'AUuPe6': 'Enter at least {num} characters, double-click to switch to batch query',
  'BC74I9': 'Note',
  'BG+fLq': 'Help Guide',
  'CLqPBU': 'Edit',
  'CMMjhY': 'Column display',
  'Gwj7xc': 'Reset',
  'I1vr0V': 'Reset Password',
  'J9jPRL': 'Replicating Success',
  'MhOy8s': 'Enter at least {num} characters.',
  'N5Lfmq': 'Not allowed file format',
  'OQBMaY': 'Email Login',
  'USKhsn': 'Search results for "{keyword}"',
  'UtE0dS': 'Action',
  'VaYh5v': 'Remember Password',
  'WgC6Gs': 'Exporting in progress, you can check it later in "<url>Export Center</url>"',
  'XeiAal': 'Delete',
  'Xjfb5m': 'Privacy Policy',
  'YpskxZ': 'Outbound Handling',
  'bqbDVw': 'Search',
  'byKmgP': '{start} to {end}, a total of {total} records',
  'eZAtxt': 'Field expansion',
  'fxYWiK': 'Please enter email',
  'gI0VX4': 'On Time Delivery',
  'gP0n6A': 'Starts with',
  'gSS3He': 'contact name',
  'hOA76J': 'Equals',
  'lSOSkG': 'Ends with',
  'oIbf2X': 'Inbound Handling',
  'pVp/bh': 'Please select a file to upload',
  'qUKj7E': 'Copy',
  'r2dEd/': 'Reset',
  'sIy67M': 'Contains',
  'uB9dmc': 'The current account does not have <strong>{menuName}</strong> menu permission, please contact the main account to enable it',
  'usAYZQ': 'Supports up to {num} queries',
  'xUjLTE': 'Search',
  'y5s4nK': 'Enter at least 2 characters',
  'zUjHmW': '<strong>Sorry, no documents related to "{keyword}" were found</strong>{break} I suggest you:{break} See the text you typed Is there a mistake{break} to remove words that may be unnecessary, such as "", "what", etc.',
  'zbkYlG': 'WINIT Provides efficient omnifulfillment solutions that makes your business sell better with less stock, resulting in lower overall costs.',
  'zkVUHd': 'Maximum of {num} queries, double-click to switch to single query',
  'zvNTfS': 'Access guide',
  '+UIRGl': 'Invoice  Summny',
  '0AJzSm': 'Tax Amount',
  '1WB+di': 'Handle exception',
  '2QzYmY': 'Cancel',
  '47GdDb': 'Close',
  '4KPJBi': 'File size should not exceed {attachmentSizeMax}M, please compress before uploading',
  '4vcHWR': 'Attachment Format/Quantity: Supports formats {attachmentFileFormat}, up to {attachmentNumMax} attachments can be uploaded, each attachment should not exceed {attachmentSizeMax}M. (Preview function is not supported temporarily after the picture is uploaded successfully)',
  '99qdsf': 'Overdue Amount',
  '9j7Ejw': 'Upload attachments',
  'A64kW0': 'Up to {maxCount} files can be uploaded',
  'F7+3p7': 'Invoice #',
  'HNFUfF': 'Please upload the attachment!',
  'J0D5h+': 'Date From',
  'JN5iZt': 'Submitted successfully',
  'PzFarD': 'Total Invoice Amount',
  'Q06UZa': 'Invoice Details',
  'T8gjTZ': 'The file name cannot contain spaces',
  'U5K9ww': 'Upload Invoice',
  'Wy9Mf2': 'Today',
  'XQVNb1': 'Billing Range',
  'YKwdXz': 'Return Reasons',
  'eUSpdN': 'More',
  'eydz7g': 'Due Date',
  'i0bc3f': 'Currency',
  'jESlL9': 'Nearly {days} days',
  'nEqIuQ': 'Invoice Date',
  'ns1bWF': 'Select Billing Period',
  'osngNl': 'Invoice Documents',
  'ptv3HC': 'In-Process Invoices',
  'qaOnvz': 'Paid Invoices',
  'qdvxnx': 'File format is limited to {allowExtensions}',
  'r0/TUu': 'OK',
  'rLn5dB': 'More',
  'sQOTXH': 'Invoice Amount',
  'v04auv': ' To ',
  'v5/qhM': 'Bill Status',
  '+Y0zrA': 'We\'ve sent a verification email to {email}. Please check your inbox and complete verification.{break}If you didn\'t receive it, <reSend>click here</reSend> to resend',
  '6AJEH3': 'New Password',
  '6Y0p2/': 'Next',
  'DQMC7I': 'The two password entries do not match',
  'FEb7U2': 'Confirm',
  'FKnMw9': 'Confirm password',
  'KOOqT/': 'Password Changed Successfully!',
  'Q4T2WD': 'This detail list displays invoice information automatically recognized by the system. When recognition fails and no corresponding details are captured, backend personnel will manually complete the information',
  'S0RL7L': 'Forgot Password',
  'S0h9rp': '6-32 characters (letters, numbers, symbols)',
  'Vcz4jn': 'Setting Successful',
  'W7shU1': 'Provide Account Information',
  'YcmSjW': 'Enter New Password',
  'Z5Nevj': 'Change Password',
  'common.changePwd': 'Change Password',
  'eEwaYk': 'Remember password? <login>Sign in</login>',
  'f+xVln': 'Please enter the confirmation password',
  'gsk33w': 'reset password ',
  'hDx3/S': 'Email',
  'sPM43N': 'Go to Email',
  't0nA+i': 'Security Verification',
  '4TdPpv': 'Total Invoice Amount：Cumulative sum of all historical invoices to date',
  'LibxI+': 'In-Process Invoice Amount：Sum of invoices with status: Under Review / Rejected / Payment Requested',
  'hOA0jT': 'Paid Invoice Amount： Sum of invoices with status: Paid',
  'zzAMrk': 'Overdue Invoice Amount：Sum of invoices with status: Under Review / Rejected / Payment Requested AND past due date',
  '7Op7Wj': 'Current Password',
  'TAdFnk': 'Confirm New Password',
  'yTXeo9': 'Invoice Management',
  '4R5GEq': 'Dashboard',
  'blEKts': 'Please enter your old password',
  '1W7mP7': 'Alaska Time',
  'DBKT4U': 'Supplier',
  'Lu0LkA': 'Vehicle Model',
  'QSV2/G': 'Order Number',
  'QV3pnn': 'Status',
  'R2D5Dv': 'Creation Time',
  'WNISgN': 'Pacific Time',
  'YJGPnI': 'Pickup Point',
  'Yqf2Bb': 'Shipping Number',
  'aloI6s': 'Eastern Time',
  'dpTOZD': 'Vehicle Transfer Order',
  'fa/Ner': 'Hawaii Time',
  'g+RRVq': 'China Standard Time',
  'gQ4+K1': 'Date',
  'ghWyE2': 'Shipping Order',
  'hCaFQn': 'Download Certificate',
  'hEQR93': 'Route',
  'j05yAV': 'Central Time',
  'sSmyfa': 'Unloading Point',
  'vGUm/N': 'Mountain Time',
  '0mnS/Y': 'Success Count: {successNum}, Failure Count: {failNum}, Failed Data File: {a1}',
  '30EC+P': 'Apply Time',
  '36+mbi': 'Processing Status',
  '4W0sU4': 'Please Enter Supplier Description',
  '6OSI7c': 'Inquiry Management',
  '7XrXMP': 'Inquiry Remarks',
  '8bfXLo': 'Inquiry Type',
  'AqMNVt': 'Batch Update Inquiry Results',
  'BYgheS': 'Download File Template',
  'I/NzUV': 'If the inquiry result is "With POD", uploading the POD is required to complete the process; other inquiry results will be automatically completed after batch update. (Note: POD = Proof of Delivery, referring to delivery confirmation document)',
  'K27qop': 'Export All',
  'MHwPat': 'Serial Number',
  'P0LBOd': 'Process',
  'TC+Nuc': 'POD File (Note: POD = Proof of Delivery)',
  'd0xdq1': 'Inquiry Result File',
  'hTgJgQ': 'Reply Time',
  'mItnls': 'Attachment Format / Quantity: Supported formats: {attachmentFileFormat}; each attachment must not exceed {attachmentSizeMax} MB. (Preview function is not temporarily supported after successful image upload)',
  'mZM5AF': 'Supplier Description',
  'vO6qbO': 'Inquiry Result',
  'vxR9vB': 'Reply By',
  'wdC9K4': 'Inquiry Processing',
  '+P5szr': 'Length (CM)',
  '/CesoY': 'Volume (CBM)',
  '/gvpF0': 'Create Work Order',
  '1ccOSo': 'Carrier',
  '46Zfck': 'Download Template',
  '48tTeD': 'Verification failed or receiving warehouse is inconsistent!',
  '6RphVF': 'Please upload file',
  '9eOwmI': 'Work Order Creation Time',
  'BqZvMO': 'Are you sure you want to cancel?',
  'C3Xyt8': 'Number of Cartons',
  'C5ShJS': 'Save Draft',
  'DN8VBR': 'Work Order Completion Time',
  'DtBqz5': 'Waybill / Other Files',
  'DzjlKZ': 'Please select estimated shipping time',
  'ENPgS/': 'Submit',
  'I0+bNm': 'Destination Warehouse',
  'KLv4lM': 'Add New Carton',
  'LURcJh': 'Description:',
  'MwjxBM': 'Weight (KG)',
  'MxxEYf': 'Collapse',
  'OVRt0j': 'Receiving Warehouse',
  'Qqmpu5': 'Are you sure you want to delete?',
  'QwslUU': 'Carton Status',
  'RBartQ': 'Submit Work Order',
  'RTQq0d': 'Carton Packing Information',
  'RyMWz0': 'Are you sure you want to submit?',
  'U17oU+': 'Tracking',
  'U6zcfC': 'Shipping Warehouse',
  'W5RoYI': 'Carton Serial Number / Sequence Number',
  'W9LJrj': 'Carton Serial Number',
  'Wdmil2': 'Expand',
  'WlP7ex': 'Only single query is supported',
  'XYdT8p': 'Transportation Method',
  'Xhn2gT': 'Please select',
  'XmRKnc': 'Remarks',
  'XoAFE4': 'Import successful!',
  'aDBVmD': 'Express Tracking Number',
  'bjzFIC': 'Estimated Shipping Time',
  'c2y2qR': 'Import Express Tracking Numbers',
  'd+Hky2': 'Width (CM)',
  'eN8cMr': 'Re-place Order',
  'egpTvD': 'Edit Work Order',
  'fr8qvK': 'File uploaded successfully, please wait for data verification result',
  'g4ZKwz': 'Work Order Status',
  'gGaW5m': 'Please enter remarks',
  'gRcn+M': 'No data available, click "Add New Carton" above',
  'h6fo89': 'Batch Create Work Orders',
  'k+30OI': 'Height (CM)',
  'k8/IM8': 'Supplier Return Management',
  'lnucNJ': 'Tracking Number',
  'lyzr6E': 'Double-click for batch query',
  'mxWvoh': 'Automatically generated based on imported express tracking numbers',
  'oH13Vj': 'Import',
  'plfeJC': 'Batch Work Order Creation File',
  'pyWapc': 'Shipping Warehouse',
  'qHs28D': 'Number of Delivery Orders',
  'rtmBm+': '1. In the imported file, items with the same "* Transportation Method, Shipping Warehouse (Name), Receiving Warehouse (Name), Carton Sequence Number" are regarded as the same carton by default; the system will automatically generate a carton serial number after import. {break} 2. For the same carton, the information of "Weight (KG), Length (CM), Width (CM), Length + Width + Height (CM), Estimated Shipping Time" must be consistent. {break} 3. Estimated Shipping Time must be accurate to the minute (format example: 2025-08-07 12:25). {break} 4. Work orders created in batch are in draft status; please confirm the shipping address is correct before submission.',
  'sk+CM/': 'Work Order Number',
  'thGDHR': 'Multiple numbers must be separated by line breaks or English commas; a maximum of {num} numbers are supported. Double-click to switch to single query.',
  'vDCwZ9': 'Upload File',
  'vNZuaz': 'File size must not exceed {attachmentSizeMax} MB',
  'vnzzbH': 'Export All',
  'vr5TVT': 'Please enter',
  'zQ7jgL': 'Please enter a number greater than 0 with a maximum of 2 decimal places',
  'RPQXYs': 'Note: Refers to logistics tracking record',
  'lC02p8': 'Note: CBM = Cubic Meter, unit for cargo volume',
  'q5WU4o': 'Note: "Waybill" refers to the shipping document with delivery details',
  '0fR+fE': 'Route',
  '2mTCCW': 'Current Stop',
  '47FYwb': 'Cancel',
  '5Dzxoy': 'Cannot exceed 20 characters',
  '7F3IvY': 'Please select',
  '7f7PkF': 'The file format is restricted to {allowExtensions}',
  '8iYIaE': 'The current stop and the next stop cannot be the same',
  'AFBy9/': 'Please take photo of the BOL and upload it',
  'ALwUe0': 'Fill in the main line driver information',
  'BIJUO+': 'Please upload the photos according to the requirements:{break}1) Capture the whole inside of the truck in one picture;{break}2) Confirm that the BOL is correctly filled out and signed',
  'BkXNm/': 'Reconfirm that the arriving time will later than ETA.',
  'BtqAem': 'Departure',
  'Ck/vXW': 'File size should not exceed {attachmentSizeMax}MB. Please compress the file before uploading',
  'Cnjc/E': 'ID Card',
  'DqjuZJ': 'Please upload the image',
  'DrIKfG': 'You can upload up to {maxCount} files',
  'G/FVOY': 'Driver \'s Name',
  'LxCyKX': 'Please upload',
  'McSzSX': 'Driver \'s License Number',
  'N2IrpM': 'Confirm',
  'P7PLVj': 'Date',
  'PbNtRA': 'Submission successful!',
  'R86IN4': 'Delay',
  'T46Urg': 'Attachment format/quantity: Supported formats: {attachmentFileFormat}. Maximum uploads: {attachmentNumMax} files. Each attachment must not exceed {attachmentSizeMax}MB.',
  'TP/Uec': 'Capture the whole inside of the truck in one picture and upload it',
  'TfnGaM': 'Next Stop',
  'V9tp+B': 'Please upload the sealed picture with clear seal number',
  'WOIPGx': 'Arrival',
  'b/lR5/': 'Pickup code',
  'hgNsC2': 'arrival',
  'p4N05H': 'Upload',
  'r4ln3K': 'Cannot exceed 50 characters',
  'vMUomP': 'Upload image',
  'y1K1YT': 'The next stop and the current stop cannot be the same',
  'yy7EDI': 'Upload',
  'f00p/7': 'Upload failed',
  'hsYvDX': 'Uploading',
  '+Mmw7M': '@2025 BASIC 3PL',
  '3boLWg': 'All events shown at local time',
  '3qvTiX': 'BASIC SHIPPING',
  '3rjr8i': 'More than <remaining></remaining>',
  '4CetJr': 'BASIC SHIPPING TRACKING NUMBER',
  '5JhyC0': '供应商已产生第一条有效轨 or 产生了干线轨迹 且未产生Dscan or RDscan',
  '6aD5NM': 'HIDE DETAILS',
  'ApmjIr': 'DESTINATION',
  'Cl8YLa': 'Only <remaining></remaining> more numbers can be input',
  'F84yRc': 'SHIPMENT DETAILS',
  'GgwgcO': 'SHIPPING SERVICE LEVEL',
  'OWrTNa': '根据跟踪号无法查询到数据或跟踪号对应的订单号的主账户不为18982058 - Basic 3PL, Inc.',
  'QBvgoS': 'TRACKING EVENTS',
  'S0sxA0': '供应商未产生第一条有效轨迹 且 未产生了干线轨迹',
  'UfCLZT': 'CLEAR ALL',
  'a1fAXn': 'STATUS',
  'aG5zxG': 'TRACKING NUMBER',
  'gQRAel': 'Add up to {maxCheckcount} tracking numbers separated by space, rows, commas, or semi-colons.',
  'gSlQXV': 'SHIP FROM LOCATION',
  'kcd/kl': 'LATEST UPDATE',
  'lCtyPk': 'SHIP DATE',
  'oTE2X0': 'Basic Shipping Standard',
  'qZOv9O': 'Basic Shipping Overnight',
  'rfHO5k': 'Basic Shipping Freight',
  'uCR6oy': 'Basic Shipping Economy',
  'uRh9uR': 'Basic Shipping Ground',
  'uUB5hA': '跟踪号产生了Dscan',
  'vdI05h': 'LAST MILE CARRIER',
  'vxuydz': '存在被标记为EXCEPTION类型的轨迹或RDscan',
  'wjT9XY': 'Add up to {count} tracking numbers separated by space, rows, commas, or semi-colons.',
  'xbAmTZ': 'Basic Shipping Express',
  'yLOhiN': 'TRACK',
  'Cpd1nk': '*Basic Shipping provides package tracking services only. For inquiries about order details, please contact Basic 3PL support.',
};
